var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnnotateAddNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4316_4387",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.647461,
    width: 20,
    height: 20,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4316_4387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.4039 16.5833C5.02879 16.5833 4.71172 16.4538 4.45269 16.1948C4.19366 15.9357 4.06415 15.6187 4.06415 15.2436V4.75644C4.06415 4.38133 4.19366 4.06426 4.45269 3.80523C4.71172 3.5462 5.02879 3.41669 5.4039 3.41669H13.4712L17.2308 7.17629V15.2436C17.2308 15.6187 17.1013 15.9357 16.8422 16.1948C16.5832 16.4538 16.2661 16.5833 15.891 16.5833H5.4039ZM5.4039 15.5H15.891C15.9658 15.5 16.0273 15.476 16.0753 15.4279C16.1234 15.3798 16.1475 15.3184 16.1475 15.2436V8H12.6475V4.5H5.4039C5.32911 4.5 5.26767 4.52404 5.21959 4.57212C5.1715 4.62021 5.14746 4.68165 5.14746 4.75644V15.2436C5.14746 15.3184 5.1715 15.3798 5.21959 15.4279C5.26767 15.476 5.32911 15.5 5.4039 15.5ZM6.85581 13.5833H14.4391V12.5H6.85581V13.5833ZM7.10581 7.75H10.6475V6.66669H7.10581V7.75ZM6.85581 11.0416H14.4391V9.95835H6.85581V11.0416Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotateAddNote);
export default __webpack_public_path__ + "static/media/annotate-add-note.2c5d10f1437f590d48d33e17eb6c6b82.svg";
export { ForwardRef as ReactComponent };